/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import katex from 'katex';
import 'katex/dist/katex.min.css';
import QuillEditor from '../../../components/Quill/Quill';
import adminServices from '../../../services/adminServices';

window.katex = katex;

const Parchment = Quill.import("parchment");
const Style = new Parchment.Attributor.Style("style", "style");
Quill.register(Style, true);

const ImageWidth = new Parchment.Attributor.Attribute("width", "width", {
  scope: Parchment.Scope.INLINE,
});
Quill.register(ImageWidth, true);

const ImageHeight = new Parchment.Attributor.Attribute("height", "height", {
  scope: Parchment.Scope.INLINE,
});
Quill.register(ImageHeight, true);

const PassageMultipleQuestions = ({ formData, setFormData, errors, setErrors }) => {
  console.log(formData,"formDataformData");
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [questionToDelete, setQuestionToDelete] = useState(null);

  const handleDeleteClick = (questionIndex) => {
    setQuestionToDelete(questionIndex);
    setDeleteConfirmOpen(true);
  };

  const handleDeleteConfirm = () => {
    if (questionToDelete === null) return;
    if (formData?.questions?.length > 1) {
      setFormData(prev => {
        const newQuestions = prev.questions.filter((_, i) => i !== questionToDelete);
        return { ...prev, questions: newQuestions };
      });
    }
    setDeleteConfirmOpen(false);
    setQuestionToDelete(null);
  };

  const handleDeleteCancel = () => {
    setDeleteConfirmOpen(false);
    setQuestionToDelete(null);
  };
  const quillRefs = {
    passageText: useRef(null),
    questions: useRef([])
  };

  const formats = React.useMemo(() => [
    "bold", "italic", "underline",
    "list", "bullet",
    "script",
    "header",
    "image",
    "formula",
    "color", "background",
    "align", "style", "width", "height"
  ], []);

  const getModules = (targetRef) => ({
    toolbar: {
      container: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ script: "sub" }, { script: "super" }],
        [{ header: [1, 2, 3, false] }],
        ["image", { formula: { customClass: 'qlformula' } }],
        [{ color: [] }, { background: [] }],
        [{ align: [] }],
        ["clean"],
      ],
      handlers: {
        image: () => {
          const input = document.createElement("input");
          input.type = "file";
          input.accept = "image/*";
          input.click();

          input.onchange = () => {
            if (input.files?.length) {
              handleFiles(input.files, targetRef);
            }
          };
        },
      },
    },
    clipboard: { matchVisual: false },
    imageResize: {
      parchment: Quill.import('parchment'),
      modules: ['Resize', 'DisplaySize', 'Toolbar']
    },
  });

  const passageModules = React.useMemo(() => getModules(quillRefs.passageText), []);

  const stableQuestionModule = React.useMemo(() => ({
    toolbar: {
      container: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ script: "sub" }, { script: "super" }],
        [{ header: [1, 2, 3, false] }],
        ["image", { formula: { customClass: 'qlformula' } }],
        [{ color: [] }, { background: [] }],
        [{ align: [] }],
        ["clean"],
      ],
      handlers: {
        image: () => {
          const input = document.createElement("input");
          input.type = "file";
          input.accept = "image/*";
          input.click();

          input.onchange = () => {
            if (input.files?.length) {
              const activeElement = document.activeElement;
              const quillContainer = activeElement.closest('.ql-container');
              if (quillContainer) {
                const quillInstance = quillContainer.__quill;
                if (quillInstance) {
                  handleFiles(input.files, { current: { getEditor: () => quillInstance } });
                }
              }
            }
          };
        },
      },
    },
    clipboard: { matchVisual: false },
    imageResize: {
      parchment: Quill.import('parchment'),
      modules: ['Resize', 'DisplaySize', 'Toolbar']
    },
  }), []);

  const updateQuestionRefs = React.useCallback((questionsLength) => {
    while (quillRefs.questions.current.length < questionsLength) {
      quillRefs.questions.current.push({
        questionText: React.createRef(),
        textExplanation: React.createRef(),
        options: []
      });
    }
  }, []);

  const handleFiles = async (files, targetRef) => {
    const quillInstance = targetRef?.current?.getEditor();
    if (!quillInstance) return;

    for (const file of files) {
      if (file.type.startsWith("image/")) {
        const range = quillInstance.getSelection(true);
        const tempId = `temp-${Date.now()}`;
        
        // Insert loading placeholder
        const loadingGif = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'%3E%3Ccircle cx='50' cy='50' r='40' stroke='%234F46E5' stroke-width='8' fill='none' stroke-dasharray='60 200' stroke-linecap='round'%3E%3CanimateTransform attributeName='transform' type='rotate' dur='1s' repeatCount='indefinite' from='0 50 50' to='360 50 50'/%3E%3C/circle%3E%3C/svg%3E";
        quillInstance.insertEmbed(range.index, "image", loadingGif);
        quillInstance.setSelection(range.index + 1);

        const url = await handleUploadImage(file);
        if (url) {
          const editorEl = quillInstance.root;
          const imgElements = editorEl.querySelectorAll('img');
          const loadingImg = Array.from(imgElements).find(img => img.src === loadingGif);
          if (loadingImg) {
            loadingImg.setAttribute("src", url);
          }
        }
      }
    }
  };

  const handleUploadImage = async (file) => {
    const formData = new FormData();
    formData.append("thumbImage", file);
    try {
      const imageUrl = await adminServices.postImag(formData);
      if (imageUrl?.ok) {
        return imageUrl.data;
      }
    } catch (error) {
      console.error("Image upload failed", error);
    }
    return null;
  };

  React.useEffect(() => {
    const passageEditor = quillRefs.passageText.current?.root;
    
    if (passageEditor) {
      const pasteHandler = (e) => {
        const items = e.clipboardData?.items;
        if (items) {
          const files = [];
          for (const item of items) {
            if (item.type.indexOf("image") !== -1) {
              e.preventDefault();
              files.push(item.getAsFile());
            }
          }
          if (files.length) handleFiles(files, quillRefs.passageText);
        }
      };

      const dropHandler = (e) => {
        e.preventDefault();
        const files = e.dataTransfer?.files;
        if (files?.length) handleFiles(files, quillRefs.passageText);
      };

      passageEditor.addEventListener("paste", pasteHandler);
      passageEditor.addEventListener("drop", dropHandler);
      passageEditor.addEventListener("dragover", (e) => e.preventDefault());

      return () => {
        passageEditor.removeEventListener("paste", pasteHandler);
        passageEditor.removeEventListener("drop", dropHandler);
      };
    }
  }, [quillRefs.passageText.current]);

  React.useEffect(() => {
    if (!quillRefs.questions.current) {
      quillRefs.questions.current = [];
    }
    updateQuestionRefs(formData?.questions?.length);
  }, [formData?.questions?.length, updateQuestionRefs]);

  const handleQuillChange = (field, value) => {
    setFormData(prev => ({ 
      ...prev, 
      [field]: value
    }));
    
    if (setErrors && errors?.[field]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[field];
        return newErrors;
      });
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    
    if (setErrors && errors?.[name]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const handleQuestionChange = (questionIndex, field, value) => {
    setFormData(prev => {
      const newQuestions = [...prev.questions];
      newQuestions[questionIndex] = { 
        ...newQuestions[questionIndex], 
        [field]: value
      };
      return { ...prev, questions: newQuestions };
    });
    
    if (setErrors && errors?.[`questions.${questionIndex}.${field}`]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[`questions.${questionIndex}.${field}`];
        return newErrors;
      });
    }
  };

  const handleQuestionFieldChange = (questionIndex, field, value) => {
    setFormData(prev => {
      const newQuestions = [...prev.questions];
      newQuestions[questionIndex] = { 
        ...newQuestions[questionIndex], 
        [field]: value
      };
      return { ...prev, questions: newQuestions };
    });
    
    if (setErrors && errors?.[`questions.${questionIndex}.${field}`]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[`questions.${questionIndex}.${field}`];
        return newErrors;
      });
    }
  };

  const handleQuestionOptionChange = (questionIndex, optionIndex, value) => {
    setFormData(prev => {
      const newQuestions = [...prev.questions];
      const newOptions = [...newQuestions[questionIndex].options];
      newOptions[optionIndex] = { 
        label: String.fromCharCode(65 + optionIndex), 
        value: value
      };
      newQuestions[questionIndex] = { 
        ...newQuestions[questionIndex], 
        options: newOptions 
      };
      return { ...prev, questions: newQuestions };
    });
    
    const optionErrorKey = `questions.${questionIndex}.options.${optionIndex}.value`;
    if (setErrors && errors?.[optionErrorKey]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[optionErrorKey];
        return newErrors;
      });
    }
  };

  const handleCorrectAnswerChange = (questionIndex, label) => {
    setFormData(prev => {
      const newQuestions = [...prev.questions];
      newQuestions[questionIndex] = { 
        ...newQuestions[questionIndex], 
        correctAnswer: label 
      };
      return { ...prev, questions: newQuestions };
    });
    
    if (setErrors && errors?.[`questions.${questionIndex}.correctAnswer`]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[`questions.${questionIndex}.correctAnswer`];
        return newErrors;
      });
    }
  };

  const addQuestion = () => {
    setFormData(prev => ({
      ...prev,
      questions: [
        ...prev.questions,
        {
          questionText: '',
          options: [
            { label: 'A', value: '' },
            { label: 'B', value: '' },
            { label: 'C', value: '' },
            { label: 'D', value: '' },
          ],
          correctAnswer: '',
          marks: '1',
          negativeMarks: '0',
          textExplanation: '',
          youtubeVideoUrl: '',
        },
      ],
    }));
  };

  const removeQuestion = (questionIndex) => {
    if (formData?.questions?.length > 1) {
      setFormData(prev => {
        const newQuestions = prev.questions.filter((_, i) => i !== questionIndex);
        return { ...prev, questions: newQuestions };
      });
    }
  };

  const addOptionToQuestion = (questionIndex) => {
    setFormData(prev => {
      const newQuestions = [...prev.questions];
      const currentOptions = newQuestions[questionIndex].options;
      if (currentOptions.length < 6) {
        newQuestions[questionIndex].options = [
          ...currentOptions,
          { 
            label: String.fromCharCode(65 + currentOptions.length), 
            value: ''
          },
        ];
      }
      return { ...prev, questions: newQuestions };
    });
  };

  const removeOptionFromQuestion = (questionIndex, optionIndex) => {
    setFormData(prev => {
      const newQuestions = [...prev.questions];
      if (newQuestions[questionIndex].options.length > 2) {
        const removedLabel = newQuestions[questionIndex].options[optionIndex].label;
        newQuestions[questionIndex].options = newQuestions[questionIndex].options.filter((_, i) => i !== optionIndex);
        newQuestions[questionIndex].options = newQuestions[questionIndex].options.map((opt, i) => ({
          ...opt,
          label: String.fromCharCode(65 + i)
        }));
        
        if (newQuestions[questionIndex].correctAnswer === removedLabel) {
          newQuestions[questionIndex].correctAnswer = '';
        }
      }
      return { ...prev, questions: newQuestions };
    });
  };

  const getOptionError = (questionIndex, optionIndex) => {
    return errors?.[`questions.${questionIndex}.options.${optionIndex}.value`];
  };

  return (
    <div className="space-y-6" id="passage-multi-form">
      {deleteConfirmOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50" id="delete-question-confirm-modal">
          <div className="bg-white rounded-lg shadow-lg p-6 w-96">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Delete Question</h3>
            <p className="text-sm text-gray-600 mb-6">
              Are you sure you want to delete <strong>Question {questionToDelete + 1}</strong>? This action cannot be undone.
            </p>
            <div className="flex justify-end gap-3">
              <button type="button" onClick={handleDeleteCancel} id="delete-question-cancel-btn" className="px-4 py-2 text-sm border border-gray-300 rounded-md">Cancel</button>
              <button type="button" onClick={handleDeleteConfirm} id="delete-question-confirm-btn" className="px-4 py-2 text-sm bg-red-600 text-white rounded-md hover:bg-red-700">Delete</button>
            </div>
          </div>
        </div>
      )}
      {/* Passage Information */}
      <div className="rounded-lg border border-green-200 p-6 mb-6" id="passage-info-section">
        <h3 className="text-lg font-medium text-gray-900 mb-6">Passage Information</h3>


        {/* Passage Text */}
        <div id="passage-text-editor">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Passage Text <span className="text-red-500">*</span>
          </label>
          <QuillEditor
            ref={quillRefs.passageText}
            id="quill-passage-text"
            value={formData.passageText || ''}
            onChange={(value) => handleQuillChange('passageText', value)}
            theme="snow"
            modules={passageModules}
            formats={formats}
            placeholder="Enter the passage text here..."
          />
          {errors?.passageText && (
            <p className="mt-1 text-sm text-red-600 flex items-center gap-1">
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
              {errors.passageText}
            </p>
          )}
        </div>
      </div>

      {/* Questions Section */}
      <div className="space-y-6 mt-6" id="questions-section">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-medium text-gray-900">Questions ({formData.questions?.length})</h3>
          <button
            type="button"
            onClick={addQuestion}
            id="add-question-btn"
            className="inline-flex items-center px-3 py-1.5 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-medium rounded-lg transition-colors duration-150"
          >
            <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
            Add Question
          </button>
        </div>

        {formData?.questions?.map((question, questionIndex) => (
          <div key={questionIndex} className="bg-white rounded-lg border-2 border-gray-300 p-6 mt-6" id={`question-card-${questionIndex}`}>
            <div className="flex items-center justify-between mb-6">
              <h4 className="text-md font-medium text-gray-900">Question {questionIndex + 1}</h4>
              <button
                type="button"
                onClick={() => handleDeleteClick(questionIndex)}
                disabled={formData?.questions?.length <= 1}
                className="p-2 text-gray-600 hover:text-red-600 hover:bg-red-50 disabled:opacity-50 disabled:cursor-not-allowed rounded-lg transition-colors duration-150"
                title="Delete Question"
                id={`delete-question-btn-${questionIndex}`}
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
              </button>
            </div>

            {/* Question Text */}
            <div className="mb-6" id={`question-text-editor-${questionIndex}`}>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Question Text <span className="text-red-500">*</span>
              </label>
              <QuillEditor
                ref={quillRefs.questions.current[questionIndex]?.questionText}
                id={`quill-question-text-${questionIndex}`}
                value={question.questionText || ''}
                onChange={(value) => handleQuestionChange(questionIndex, 'questionText', value)}
                theme="snow"
                modules={stableQuestionModule}
                formats={formats}
                placeholder="Enter the question..."
              />
              {errors?.[`questions.${questionIndex}.questionText`] && (
                <p className="mt-1 text-sm text-red-600 flex items-center gap-1">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                  {errors[`questions.${questionIndex}.questionText`]}
                </p>
              )}
            </div>

            {/* Marks and Negative Marks */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
              <div>
                <label htmlFor={`marks-${questionIndex}`} className="block text-sm font-medium text-gray-700 mb-2">
                  Marks <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id={`marks-${questionIndex}`}
                  
                  value={question.marks || ''}
                  onChange={(e) => handleQuestionFieldChange(questionIndex, 'marks', e.target.value)}
                  className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm bg-white ${
                    errors?.[`questions.${questionIndex}.marks`] ? 'border-red-500 bg-red-50' : 'border-gray-300'
                  }`}
                />
                {errors?.[`questions.${questionIndex}.marks`] && (
                  <p className="mt-1 text-sm text-red-600 flex items-center gap-1">
                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                    </svg>
                    {errors[`questions.${questionIndex}.marks`]}
                  </p>
                )}
              </div>
              <div>
                <label htmlFor={`negativeMarks-${questionIndex}`} className="block text-sm font-medium text-gray-700 mb-2">
                  Negative Marks
                </label>
                <input
                  type="text"
                  id={`negativeMarks-${questionIndex}`}
                  value={question.negativeMarks || ''}
                  onChange={(e) => handleQuestionFieldChange(questionIndex, 'negativeMarks', e.target.value)}
                  className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm bg-white ${
                    errors?.[`questions.${questionIndex}.negativeMarks`] ? 'border-red-500 bg-red-50' : 'border-gray-300'
                  }`}
                />
                {errors?.[`questions.${questionIndex}.negativeMarks`] && (
                  <p className="mt-1 text-sm text-red-600 flex items-center gap-1">
                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                    </svg>
                    {errors[`questions.${questionIndex}.negativeMarks`]}
                  </p>
                )}
              </div>
            </div>

            {/* Options */}
            <div className="mb-6">
              <div className="flex items-center justify-between mb-4">
                <label className="block text-sm font-medium text-gray-700">Options</label>
                <button
                  type="button"
                  onClick={() => addOptionToQuestion(questionIndex)}
                  disabled={question.options.length >= 6}
                  id={`add-option-btn-${questionIndex}`}
                  className="text-xs px-2 py-1 bg-gray-100 hover:bg-gray-200 disabled:bg-gray-50 disabled:cursor-not-allowed text-gray-700 rounded transition-colors duration-150"
                >
                  + Add Option
                </button>
              </div>

              <div className="space-y-4" id={`options-list-${questionIndex}`}>
                {question.options.map((option, optionIndex) => {
                  const optionError = getOptionError(questionIndex, optionIndex);
                  
                  // Ensure option refs exist
                  if (!quillRefs.questions.current[questionIndex]) {
                    quillRefs.questions.current[questionIndex] = {
                      questionText: React.createRef(),
                      textExplanation: React.createRef(),
                      options: []
                    };
                  }
                  if (!quillRefs.questions.current[questionIndex].options[optionIndex]) {
                    quillRefs.questions.current[questionIndex].options[optionIndex] = React.createRef();
                  }
                  
                  return (
                    <div key={optionIndex} className="space-y-2" id={`option-row-${questionIndex}-${option.label}`}>
                      <div className="flex items-start gap-2">
                        <div className="flex items-center pt-3 flex-shrink-0">
                          <input
                            type="radio"
                            name={`correctAnswer-${questionIndex}`}
                            checked={question.correctAnswer === option.label}
                            onChange={() => handleCorrectAnswerChange(questionIndex, option.label)}
                            className="w-4 h-4 text-indigo-600 focus:ring-indigo-500 cursor-pointer"
                            id={`correct-answer-radio-${questionIndex}-${option.label}`}
                          />
                        </div>
                        <div className="flex items-center pt-3 flex-shrink-0">
                          <span className="text-sm font-semibold text-gray-700 min-w-[24px] bg-gray-100 px-2 py-1 rounded border border-gray-300">
                            {option.label}
                          </span>
                        </div>
                        <div className="flex-1 min-w-0" id={`option-editor-${questionIndex}-${option.label}`}>
                          <QuillEditor
                            ref={quillRefs.questions.current[questionIndex].options[optionIndex]}
                            id={`quill-option-${questionIndex}-${option.label}`}
                            value={option.value || ''}
                            onChange={(value) => handleQuestionOptionChange(questionIndex, optionIndex, value)}
                            theme="snow"
                            modules={stableQuestionModule}
                            formats={formats}
                            placeholder={`Enter option ${option.label}...`}
                          />
                        </div>
                        <button
                          type="button"
                          onClick={() => removeOptionFromQuestion(questionIndex, optionIndex)}
                          disabled={question.options.length <= 2}
                          id={`option-delete-btn-${questionIndex}-${option.label}`}
                          className="p-2 text-gray-600 hover:text-red-600 hover:bg-red-50 disabled:opacity-50 disabled:cursor-not-allowed rounded-lg transition-colors duration-150 mt-1 flex-shrink-0"
                        >
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                          </svg>
                        </button>
                      </div>
                      
                      {optionError && (
                        <p className="ml-12 text-sm text-red-600 flex items-center gap-1">
                          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                          </svg>
                          {optionError}
                        </p>
                      )}
                    </div>
                  );
                })}
              </div>
              
              {errors?.[`questions.${questionIndex}.correctAnswer`] && (
                <p className="mt-2 text-sm text-red-600 flex items-center gap-1">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                  {errors[`questions.${questionIndex}.correctAnswer`]}
                </p>
              )}
            </div>

            {/* Explanation */}
            <div className="mb-6" id={`explanation-editor-${questionIndex}`}>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Text Explanation <span className="text-red-500">*</span>
              </label>
              <QuillEditor
                ref={quillRefs.questions.current[questionIndex]?.textExplanation}
                id={`quill-explanation-${questionIndex}`}
                value={question.textExplanation || ''}
                onChange={(value) => handleQuestionChange(questionIndex, 'textExplanation', value)}
                theme="snow"
                modules={stableQuestionModule}
                formats={formats}
                placeholder="Explain the correct answer..."
              />
              {errors?.[`questions.${questionIndex}.textExplanation`] && (
                <p className="mt-1 text-sm text-red-600 flex items-center gap-1">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                  {errors[`questions.${questionIndex}.textExplanation`]}
                </p>
              )}
            </div>

            {/* YouTube URL */}
            <div>
              <label htmlFor={`youtube-${questionIndex}`} className="block text-sm font-medium text-gray-700 mb-2">
                YouTube Video Explanation (Optional)
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg className="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                    <path fillRule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <input
                  type="text"
                  id={`youtube-${questionIndex}`}
                  value={question.youtubeVideoUrl || ''}
                  onChange={(e) => handleQuestionFieldChange(questionIndex, 'youtubeVideoUrl', e.target.value)}
                  placeholder="https://youtube.com/watch?v=..."
                  className={`w-full pl-10 pr-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm transition-colors bg-white ${
                    errors?.[`questions.${questionIndex}.youtubeVideoUrl`] ? 'border-red-500 bg-red-50' : 'border-gray-300'
                  }`}
                />
              </div>
              {errors?.[`questions.${questionIndex}.youtubeVideoUrl`] && (
                <p className="mt-1 text-sm text-red-600 flex items-center gap-1">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                  {errors[`questions.${questionIndex}.youtubeVideoUrl`]}
                </p>
              )}
            </div>
          </div>
        ))}

        {errors?.questions && typeof errors.questions === 'string' && (
          <p className="mt-2 text-sm text-red-600 flex items-center gap-1">
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
            {errors.questions}
          </p>
        )}
      </div>
    </div>
  );
};

export default PassageMultipleQuestions;